import { useEffect, useState } from "react";
// REDUX
import { useGetAdapterQuery } from "../../redux/adapters/adapterAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { AdapterInterface } from "../../interfaces/Adapter.interface";
// CONSTANTS
import { BLANK_ADAPTER } from "../../constants/adapter";

export default function useGetOneAdapter({ id = "--" }: { id: string }) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [adapter, setAdapter] = useState<AdapterInterface>({ ...BLANK_ADAPTER });
  const [token, setToken] = useState<string | null>(null);
  const [errorObject, setErrorObject] = useState<any>({});
  const [errorMessage, setErrorMessage] = useState<string>("Error");

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const { data, isLoading, isError, isFetching, error } = useGetAdapterQuery(
    { token, id },
    { skip: !token || !id || id === "--", refetchOnMountOrArgChange: true },
  );

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    GETJwtToken().then(setToken);
  }, []);

  useEffect(() => {
    if (data && data.data) {
      setAdapter(data.data);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setErrorObject(error);
    }
  }, [error]);

  useEffect(() => {
    if (errorObject && errorObject.data && errorObject.data.message) {
      setErrorMessage(errorObject.data.message);
    }
  }, [errorObject]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return {
    adapter,
    isLoadingGetOneAdapter: isLoading || isFetching,
    errorMessageGetOneAdapter: errorMessage,
    isErrorGetOneAdapter: isError,
  };
}
